import { Platform } from "react-native";
import { BuildBootstrapFunctionReturn } from "@lookiero/messaging-react";
import { fetchHttpPost } from "@lookiero/sty-psp-http";
import { VERSION } from "../../version";
import { getGame, saveGame } from "../domain/game/model/httpGames";
import { httpGameByCustomerIdView } from "../projection/game/httpGameByCustomerIdView";
import { baseBootstrap } from "./baseBootstrap";

type OS = typeof Platform.OS;
type Device = Exclude<OS, "macos" | "windows">;
const device = Platform.OS as Device;

interface BootstrapFunctionArgs {
  readonly apiUrl: () => string;
  readonly getAuthToken: () => Promise<string>;
}

interface BootstrapFunction {
  (args: BootstrapFunctionArgs): BuildBootstrapFunctionReturn;
}

const bootstrap: BootstrapFunction = ({ apiUrl, getAuthToken }) => {
  const httpPost = fetchHttpPost({ apiUrl, getAuthToken, device, version: VERSION });

  return baseBootstrap({
    gameByCustomerIdView: httpGameByCustomerIdView({ httpPost }),
    getGame,
    saveGame,
    gamesDependencies: [{ httpPost }],
  });
};

export { bootstrap };
